import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ConfigProvider, App as AntdApp, theme as antdTheme } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { useEffect } from 'react'
import { useThemeStore } from './stores/themeStore'
import AppLayout from './components/layouts/AppLayout'
import ProtectedRoute from './components/common/ProtectedRoute'
import Dashboard from './pages/Dashboard'
import AnalysisWorkbench from './pages/AnalysisWorkbench'
import DataExplorer from './pages/DataExplorer'
import AIExplore from './pages/AIExplore'
import Alerts from './pages/Alerts'
import ReportCenter from './pages/ReportCenter'

// 共享 token（浅色/深色通用）
const sharedToken = {
  colorPrimary: '#1677FF',
  colorSuccess: '#52C41A',
  colorWarning: '#FAAD14',
  colorError: '#FF4D4F',
  colorInfo: '#1677FF',
  borderRadius: 8,
  fontSize: 14,
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'`,
}

// 浅色模式额外 token
const lightThemeToken = {
  colorBgLayout: '#F8FAFC',
  colorBgContainer: '#FFFFFF',
  colorBorder: '#E2E8F0',
  colorBorderSecondary: '#F1F5F9',
  colorText: '#1E293B',
  colorTextSecondary: '#64748B',
  colorTextTertiary: '#94A3B8',
  colorTextBase: '#1F1F1F',
  colorBgBase: '#FFFFFF',
}

// 组件级配置
const componentConfig = {
  Button: {
    controlHeight: 40,
    paddingContentHorizontal: 24,
  },
  Input: {
    controlHeight: 40,
  },
  Select: {
    controlHeight: 40,
  },
}

function App() {
  const theme = useThemeStore((state) => state.theme)

  // 根据主题状态更新 document 的 class，用于全局样式
  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [theme])

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        algorithm: theme === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          ...sharedToken,
          ...(theme === 'light' ? lightThemeToken : {}),
        },
        components: componentConfig,
      }}
    >
      <AntdApp>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            {/* 受保护的主应用布局 */}
            <Route path="/" element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="analysis" element={<AnalysisWorkbench />} />
              <Route path="data" element={<DataExplorer />} />
              <Route path="ai-explore" element={<AIExplore />} />
              <Route path="alerts" element={<Alerts />} />
              <Route path="reports" element={<ReportCenter />} />
            </Route>

            {/* 404 重定向 */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AntdApp>
    </ConfigProvider>
  )
}

export default App
